import type { IAddress, IAuctionHouse, IGuestUser, IItem } from '@/types';
import { getFullName } from '@/utils';

const defaultValues: IAddress = {
  streetAddress: '',
  zipCode: '',
  city: '',
  countryCode: '',
  province: '',
};

const getAddress = ({
  city,
  countryCode,
  province,
  streetAddress,
  zipCode,
}: IAddress = defaultValues): IAddress => ({
  streetAddress,
  zipCode,
  city,
  countryCode,
  province,
});

interface IUseQuoteSummaryReturnValue {
  auctionCode: string;
  auctionDate: string;
  auctionHouseAddress: IAddress;
  auctionName: string;
  batchCode: string;
  itemInfo: Omit<IItem, 'category' | 'fragility'>;
  shippingAddress: IAddress;
  shippingEmail: string;
  shippingPhone: string;
  shippingRecipient: string;
  userFullname: string;
}
interface IShipping extends IAddress {
  email?: string;
  name?: string | undefined;
  phone?: string;
  recipient?: string | undefined;
}

interface IUseQuoreSummaryParams {
  auctionHouse: IAuctionHouse | undefined;
  item: Omit<IItem, 'category' | 'fragility'> | undefined;
  shipping: IAddress | undefined;
  user: IGuestUser | undefined;
}

export const useQuoteSummary = (params: IUseQuoreSummaryParams): IUseQuoteSummaryReturnValue => {
  const { auctionHouse, item, shipping, user } = params;

  const shippingInfo = shipping as IShipping | undefined;
  const fullname = user ? getFullName(user) : '';
  const shippingAddress = getAddress(shipping);
  const auctionHouseAddress = getAddress(auctionHouse);
  return {
    auctionCode: auctionHouse?.auctionCode ?? '',
    auctionDate: auctionHouse?.auctionDate ?? '',
    auctionName: auctionHouse?.name ?? '',
    batchCode: auctionHouse?.batchCode ?? '',
    userFullname: fullname,
    shippingAddress,
    shippingRecipient: shippingInfo?.recipient ?? shippingInfo?.name ?? '',
    shippingEmail: shippingInfo?.email ?? shippingInfo?.email ?? '',
    shippingPhone: shippingInfo?.phone ?? shippingInfo?.phone ?? '',
    auctionHouseAddress,
    itemInfo: {
      height: item?.height ?? 0,
      name: item?.name ?? '',
      length: item?.length ?? 0,
      weight: item?.weight ?? 0,
      width: item?.width ?? 0,
    },
  };
};
